export enum AccessLevel {
  ReadWrite = "rw",
  ReadOnly = "ro",
  Hidden = "hidden"
}
